import React from 'react';
import { Form, Input } from '@agconnections/grow-ui';
import GrowUIFormField from 'components/Forms/GrowUIFormField';

const LegalNameField = () => {
  return (
    <Form.Field label="Legal Name">
      <GrowUIFormField control={Input} id="legalName" name="legalName" />
    </Form.Field>
  );
};

export default LegalNameField;
